import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SplashScreen } from '@capacitor/splash-screen';
import './index.css';
import './lib/design/boot';
import './lib/posthog';
import App from './App';
import { BUILD_FLAVOR_STAMP } from './lib/flavor';
import { startTextScale } from './lib/textScale';

// Which app this bundle was built as (see BUILD_FLAVOR_STAMP); also lets the
// release workflows verify the build.
document.documentElement.dataset.build = BUILD_FLAVOR_STAMP;

// Chat text follows the phone's text-size setting.
startTextScale();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// The native SplashScreen plugin is configured with launchAutoHide: false (see
// capacitor.config.ts) so it stays on screen — covering the WKWebView's blank
// default background — until this fires. Double rAF waits for the browser to
// actually paint the just-rendered tree (the orange FullScreenSpinner, itself
// on the same #FF8D23) before swapping away the native splash, so the
// handoff has no gap where the WebView's white background could show through.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    SplashScreen.hide();
  });
});
